import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import pedidoEvento from "../../enums/pedidoEvento";
import { formatDateTime, mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [lista, setLista] = useState([]);
  const [tiposEventos, setTiposEventos] = useState([]);
  const [filtros, setFiltros] = useState(
    mergeParams(
      { codigo: 0, escola: "", ultimoEvento: 0, codigoNF: "" },
      location
    )
  );

  useEffect(() => {
    listarPedidos();
    listarTiposEventos();
  }, []);

  const listarPedidos = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);

    if (!filtrosEnviar.ultimoEvento) {
      filtrosEnviar.ultimoEvento = "";
    }

    setCarregando(true);
    api
      .get("pedidos/listarGerenciamento", filtrosEnviar)
      .then((pedidos) => {
        pedidos.forEach((p) => {
          p.codigo = p.pedidoId.toString().padStart(5, "0");
          p.pedidoDataHora = formatDateTime(p.pedidoDataHora, "D/M/Y h:m"); //new Date(p.pedidoDataHora).toLocaleString('pt-BR');
          p.pedidoValorTotal = (p.pedidoValorTotal / 100).toLocaleString(
            "pt-BR",
            { style: "currency", currency: "BRL" }
          );
          p.ultimoEvento = p.ultimoEventoNome ? p.ultimoEventoNome : 'Pendente';
          p.customStyle = { backgroundColor: p.ultimoEventoId ? p.ultimoEventoCor : 'rgb(255, 145, 138)'};
        });

        setCarregando(false);
        setLista(pedidos);
      })
      .catch((err) => {
        notification("error", "Erro ao listar os pedidos");
      });
  };

  const listarTiposEventos = () => {
    api
      .get("eventosPedido/listar")
      .then(tiposEventos => {
        setTiposEventos(tiposEventos);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const tRegistros = {
    title: "Pedidos Da Escola",
    onLineClick: (id) =>
      history.push(`/app/pedidos-gerenciamento/${id.pedidoId}`),

    columns: [
      {
        name: "codigo",
        label: "Código",
        style: { fontWeight: "bolder", fontSize: 13 },
      },
      {
        name: "ultimoEvento",
        label: "Situação (último evento)"
      },
      {
        name: "escolaNome",
        label: "Escola",
        style: { fontWeight: "bolder", fontSize: 13 },
      },
      {
        name: "pedidoDataHora",
        label: "Data/hora",
      },
      {
        name: "pedidoValorTotal",
        label: "Valor",
      },
      {
        name: "pedidoCodigoNF",
        label: "Código da nota fiscal",
      },
    ],
    array: lista,
  };

  const fPedido = {
    title: "Filtros",
    form: {
      codigo: {
        label: "Código",
        type: "number",
        space: 3,
        value: filtros.codigo,
      },
      escola: {
        label: "Escola",
        type: "text",
        space: 3,
        value: filtros.escola,
      },
      ultimoEvento: {
        label: "Último evento",
        type: "select",
        space: 3,
        value: filtros.ultimoEvento,
        emptyItem: true,
        emptyItemText: "(Todas)",
        array: {
          data: tiposEventos,
          value: "id",
          desc: "nome",
        },
      },
      codigoNF: {
        label: "Código da nota fiscal",
        type: "number",
        space: 3,
        value: filtros.codigoNF,
      },
    },
    submit: {
      label: "Carregar",
      action: listarPedidos,
    },

    urlParams: true,
    history,
    location,
  };

  return (
    <div>
      <Form formData={fPedido} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
const comboPedidos = [
  {
    id: 1,
    desc: "Nota fiscal emitida",
  },
  {
    id: 2,
    desc: "Enviado",
  },
  {
    id: 3,
    desc: "Entregue",
  },
  {
    id: 4,
    desc: "Cancelado",
  },
  {
    id: 5,
    desc: "Mensagem",
  },
  {
    id: 6,
    desc: "Enviado para separação",
  },
  {
    id: 7,
    desc: "Aguardando Retirada da Transportadora",
  },
  {
    id: 8,
    desc: "Recolhido pela Transportadora",
  },
  {
    id: 9,
    desc: "Extraviado",
  },
];
